import { useContext, useEffect, useState } from "react";
import CampaignContext from "../../../contexts/CampaignContext";
import UserContext from "../../../contexts/UserContext";
import restService from "../../../restService";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { PulseLoader } from "react-spinners";
import { handleRewardTypes } from "../../../utilities";
const RecentEntries = () => {
  const navigate = useNavigate();

  const [entries, setEntries] = useState([]);
  const [pages, setPages] = useState(1);
  // const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [loading, setLoading] = useState(true);

  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  const [page, setPage] = useState(1);
  const [pageNumberLimit, setPageNumberLimit] = useState(3);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(3);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [containStations, setContainStations] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNextBtn = () => {
    setPage(page + 1);
    // navigate("#top");

    scrollToTop();

    if (page + 1 > maxPageNumberLimit) {
      setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePageNumberClick = (e) => {
    setPage(Number(e.target.textContent));
    // navigate("#top");
  };

  // console.log([...Array(Math.max(0, pages - 1))].length - pages + 1);

  const handlePrevBtn = () => {
    setPage(page - 1);
    // navigate("#top");

    if ((page - 1) % pageNumberLimit === 0) {
      setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, [campaign, page]);

  const fetchEntries = async () => {
    try {
      const end = "";
      // const end = createdTo ? new Date(createdTo).toISOString() : "";
      const {
        data: { status, data, totalCount, numberOfPages, currentPage, limit },
      } = await restService.Entries.getEntries(
        campaign.id,
        page - 1,
        size,
        // end,
        user.accessToken
      );
      setLoading(false);
      setEntries(data);
      setPages(numberOfPages);

      data.map((entry) => {
        if (entry.station) {
          setContainStations(true);
        }
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <div className="w-full mt-6">
      <div className="flex items-center ">
        <div className="mr-auto">
          <h2 className="text-xl md:ml-6">Recent Entries</h2>
        </div>
        {/* <div className="mx-3">
          <button
            className="flex items-center hover:bg-[#F4F4F4] border border-gray-400	rounded py-1 px-3"
            type="button"
          >
            <span className="px-1">
              <svg
                width="9"
                height="7"
                viewBox="0 0 7 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.8225 0L3.5 2.67167L6.1775 0L7 0.8225L3.5 4.3225L0 0.8225L0.8225 0Z"
                  fill="#24211D"
                />
              </svg>
            </span>
            <span className="text-xs md:text-sm px-1 ">This Week</span>
          </button>
        </div> */}
      </div>
      <div className="mt-6 bg-white align-middle  inline-block min-w-full ">
        <table className="w-full bg-white border-b-lg shadow-sm ">
          <thead className="bg-[#F4F4F4] rounded py-2">
            <tr id="top">
              <th className="text-left px-3 py-4 text-xs md:text-sm  font-normal ">
                Date
              </th>

              {containStations && (
                <th className="text-left px-3 py-4 text-xs md:text-sm  font-normal">
                  Outlet
                </th>
              )}

              <th className="text-left px-3 py-4 text-xs md:text-sm  font-normal ">
                Customer
              </th>
              <th className="text-left px-3 py-4 text-xs md:text-sm  font-normal  ">
                {" "}
                Reward
              </th>
            </tr>
          </thead>

          <tbody className="text-[#848484]">
            {loading && (
              <tr className="w-full">
                <td className="text-center" colSpan="5">
                  <div className="my-8 mx-auto">
                    <PulseLoader color="#FF6A3A" />
                  </div>
                </td>
              </tr>
            )}

            {entries && entries?.length < 1 && !loading && (
              <tr className="w-full">
                <td className="text-center" colSpan="5">
                  <div className="my-8 mx-auto">
                    <img
                      src={require("../../../assets/images/noData.svg")}
                      alt=""
                      className="mx-auto"
                    />
                  </div>
                </td>
              </tr>
            )}
            {entries &&
              entries?.length > 0 &&
              entries?.map((value, index, array) => (
                <tr
                  key={index}
                  className="hover:bg-[#F4F4F4] hover:cursor-pointer focus:bg-[#F4F4F4] focus:cursor-pointer "
                >
                  <td className=" text-left px-2 whitespace-nowrap text-xs md:text-sm  text-[#848484] py-6 px-auto">
                    {moment(new Date(value?.created)).format(
                      "DD/MM/YYYY, h:mm:ss A"
                    )}
                  </td>

                  {containStations && (
                    <td className="px-2 text-left  whitespace-nowrap text-xs md:text-sm  text-[#848484] py-6 pl-4 capitalize">
                      {value?.station}
                    </td>
                  )}

                  <td className="px-2 text-left  whitespace-nowrap text-xs md:text-sm  text-[#848484] py-6 pl-4">
                    {value?.msisdn}
                  </td>
                  <td className="px-2 text-left whitespace-nowrap text-xs md:text-sm  text-[#848484] py-6 pl-4">
                    {handleRewardTypes(
                      value?.rewardType?.replace("_", " "),
                      value?.amount
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="text-right py-4 px-5">
          <div className="flex items-center justify-end">
            <button
              onClick={() => handlePrevBtn()}
              disabled={
                pages &&
                page === [...Array(Math.max(0, pages - 1))]?.length - pages + 2
                  ? true
                  : false
              }
              className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            {pages &&
              [...Array(Math.max(0, pages - 1))]?.map((value, index) => {
                if (
                  index + 1 < maxPageNumberLimit + 1 &&
                  index + 1 > minPageNumberLimit
                )
                  return (
                    <button
                      key={index}
                      type="button"
                      onClick={(e) => handlePageNumberClick(e)}
                      className={
                        page === index + 1
                          ? " mx-1 py-1.5 px-3 rounded text-sm bg-[#FF6A3A] text-white"
                          : "bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-3 rounded text-sm hover:bg-[#FF6A3A] hover:text-white"
                      }
                    >
                      {index + 1}
                    </button>
                  );
              })}
            <button
              onClick={() => handleNextBtn()}
              disabled={
                pages && page === [...Array(Math.max(0, pages - 1))]?.length
                  ? true
                  : false
              }
              className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentEntries;
